import { Common } from '@stockbit/ui';
import {
  BlockedStateWrapper,
  Img,
  ContentWrapper,
  BlockedDesc,
} from './styled';

const { Text } = Common;

type BlockedStateProps = {
  username: string;
};

const BlockedState = ({ username }: BlockedStateProps) => (
  <BlockedStateWrapper>
    <Img src="/images/user-profile-blocked.png" alt="Blocked stream" />
    <ContentWrapper>
      <Text family="bold" size="18px" mb="10px">
        {username} is blocked
      </Text>
      <BlockedDesc>
        Kamu tidak bisa melihat postingan ini maupun mengirim pesan. Buka untuk
        melihat postingan ini.
      </BlockedDesc>
    </ContentWrapper>
  </BlockedStateWrapper>
);
export default BlockedState;
